<!-- Mobile backdrop -->
@if (isSidebarOpen) {
  <button
    type="button"
    aria-label="Close sidebar"
    class="md:hidden fixed inset-0 z-30 bg-black/50"
    (click)="closeSidebar()"></button>
}

<aside
  class="fixed top-0 left-0 z-40 w-64 h-screen pt-17 transition-transform -translate-x-full bg-white border-r border-gray-200 md:translate-x-0 flex flex-col"
  aria-label="Sidenav"
  id="drawer-navigation"
  [ngClass]="{
    '-translate-x-full': !isSidebarOpen,
    'translate-x-0': isSidebarOpen,
  }">
  <div class="flex-1 overflow-y-auto py-5 px-3 bg-white">
    <a
      href="#"
      class="sm:hidden flex justify-between items-center p-2 py-4 w-full border-b border-gray-100 hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-200"
      type="button">
      <span class="sr-only">Open user menu</span>
      <div class="flex items-center">
        <img
          src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/avatars/michael-gough.png"
          class="mr-3 w-8 h-8 rounded-full"
          alt="Bonnie avatar" />
        <div class="text-left">
          <div class="font-semibold leading-none text-gray-900 mb-0.5">
            {{ fullName }}
          </div>
          <div class="text-sm text-gray-500">{{ email }}</div>
        </div>
      </div>
    </a>
    <div class="w-full grid gap-y-2">
      <icaredx-button
        class="leading-normal sm:hidden"
        color="secondary"
        (clicked)="openFilePicker()">
        <div class="inline-flex items-center gap-x-2">
          @if (loadingFile()) {
            <icaredx-spinner size="small" class="text-white"></icaredx-spinner>
            <span>Uploading...</span>
          } @else {
            <mat-icon class="mr-2 !w-3.5 !h-3.5" svgIcon="file-plus"></mat-icon>
            <span>Add document</span>
          }
        </div>
      </icaredx-button>

      @if (loadingBookingIntent()) {
      } @else if (!shouldShowResumeBookingAction) {
        <icaredx-button
          class="leading-normal sm:hidden"
          color="primary"
          (clicked)="openNewAppointmentDialog()">
          <mat-icon
            class="mr-2 !w-3.5 !h-3.5"
            svgIcon="calendar-plus-2"></mat-icon>
          Book Appointment
        </icaredx-button>
      } @else {
        <icaredx-button
          class="leading-normal sm:hidden"
          color="primary"
          (clicked)="openCheckoutDialog()">
          <mat-icon
            class="mr-2 !w-3.5 !h-3.5"
            svgIcon="calendar-plus-2"></mat-icon>
          {{ resumeBookingLabel }}
        </icaredx-button>
      }
    </div>
    <icaredx-file-input #fileInput class="hidden"></icaredx-file-input>
    <ul class="py-4 sm:py-0 space-y-4 border-t border-gray-100 sm:border-t-0">
      @for (navItem of navItems(); track navItem.label) {
        @if (navItem.children && navItem.children.length > 0) {
          <li>
            <a
              type="button"
              class="flex items-center p-2 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100"
              [routerLink]="navItem.route"
              routerLinkActive="bg-gray-100"
              (click)="closeSidebar()"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="navItem.collapsed = !navItem.collapsed">
              <svg
                aria-hidden="true"
                class="flex-shrink-0 w-6 h-6 text-gray-400 transition duration-75"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                  clip-rule="evenodd"></path>
              </svg>
              <span class="flex-1 ml-3 text-left whitespace-nowrap">{{
                navItem.label
              }}</span>
              <svg
                aria-hidden="true"
                class="w-6 h-6"
                [class.rotate-180]="!navItem.collapsed"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clip-rule="evenodd"></path>
              </svg>
            </a>

            @if (!navItem.collapsed) {
              <ul id="dropdown-pages" class="py-2 space-y-2">
                @for (subItem of navItem.children; track subItem.label) {
                  <li>
                    <a
                      [routerLink]="navItem.route + '/' + subItem.route"
                      routerLinkActive="bg-gray-100"
                      (click)="closeSidebar()"
                      class="flex items-center p-2 pl-11 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100"
                      >{{ subItem.label }}</a
                    >
                  </li>
                }
              </ul>
            }
          </li>
        }
        <!-- single nav item -->
        @else {
          <li>
            <a
              [routerLink]="navItem.route"
              routerLinkActive="bg-gray-100"
              (click)="closeSidebar()"
              class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg hover:bg-gray-100 group">
              @let icon = navItem?.icon;
              @if (icon) {
                <mat-icon
                  [svgIcon]="icon"
                  class="w-6 h-6 text-gray-400!"></mat-icon>
              }

              <span class="flex-1 ml-3 whitespace-nowrap">{{
                navItem.label
              }}</span>
              @if (navItem.route === 'chat' && totalUnreadCount() > 0) {
                <span class="ml-auto flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-blue-600 text-white text-[10px] font-medium leading-none">
                  {{ totalUnreadCount() }}
                </span>
              }
              @if (navItem.data?.['live']) {
                <span class="ml-auto flex items-center justify-center h-5 px-2 rounded-full bg-blue-600 text-white text-[10px] font-semibold leading-none tracking-wide">
                  LIVE
                </span>
              }
            </a>
          </li>
        }
      }
    </ul>
  </div>

  <div class="px-3 w-full bg-white z-20">
    <ul class="sm:hidden block py-4 space-y-2">
      <li>
        <button
          class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg hover:bg-gray-100 group"
          (click)="logout()">
          <svg
            class="flex-shrink-0 w-6 h-6 text-gray-400 transition duration-75 group-hover:text-gray-900"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <path
              clip-rule="evenodd"
              fill-rule="evenodd"
              d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"></path>
          </svg>
          <span class="flex-1 ml-3 whitespace-nowrap">Sign out</span>
        </button>
      </li>
    </ul>
    <ul class="pb-3 pl-2 space-y-2">
      <li>
        <button
          class="flex items-center text-sm text-gray-500 hover:text-gray-900 group"
          (click)="openSupportTicketDialog()">
          <mat-icon
            svgIcon="support"
            class="shrink-0 w-3.5! h-3.5! text-gray-500 transition duration-75 group-hover:text-gray-900!]" />

          <span class="ml-2">Technical support</span>
        </button>
      </li>
    </ul>
  </div>
</aside>
